import { abtastyService } from '@/services';
import useVariation from '@hooks/useVariation';
import { Button } from '../../../components/tailwind';
import { useCartSummary } from '../hooks';

const CheckoutButtonWidget = () => {
  const { discountedSubtotal, itemCount } = useCartSummary();
  const isVariant = useVariation('Mini Cart');

  return (
    <div className='tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-2 tw:p-3'>
      <div className='tw:flex tw:w-full tw:items-center tw:justify-between tw:gap-5 tw:px-2 tw:py-2 tw:text-sm tw:font-semibold'>
        <span>
          {itemCount} {itemCount === 1 ? 'item' : 'items'}
        </span>
        <span>Subtotal: {discountedSubtotal}</span>
      </div>

      {!isVariant && (
        <div className='tw:flex tw:w-full tw:items-center tw:gap-2'>
          <div className='tw:w-1/3'>
            <Button
              className='tw:px-0 tw:py-0 tw:text-sm tw:font-bold tw:text-muted'
              variant='unstyled'
              size='base'
              href='/cart'
              isInternalLink={true}
              fullWidth='all'
              onClick={() => abtastyService.trackAction('Mini Cart: View Cart', 'Mini Cart: View Cart')}>
              VIEW CART
            </Button>
          </div>
          <div className='tw:w-2/3'>
            <Button
              variant='primary'
              size='base'
              href='/checkout'
              fullWidth='all'
              onClick={() => abtastyService.trackAction('Mini Cart: Checkout', 'Mini Cart: Checkout')}>
              CHECKOUT
            </Button>
          </div>
        </div>
      )}

      {isVariant && (
        <>
          <Button
            variant='primary'
            size='lg'
            href='/checkout'
            fullWidth='all'
            onClick={() => abtastyService.trackAction('Mini Cart: Checkout', 'Mini Cart: Checkout')}>
            CHECKOUT
          </Button>
          <Button
            variant='tertiary'
            size='lg'
            href='/cart'
            fullWidth='all'
            onClick={() => abtastyService.trackAction('Mini Cart: View Cart', 'Mini Cart: View Cart')}>
            VIEW CART
          </Button>
          <p className='tw:mb-0 tw:text-center tw:text-xs tw:text-muted'>
            <span>Shipping & Taxes Calculated at Checkout</span>
          </p>
        </>
      )}
    </div>
  );
};

export default CheckoutButtonWidget;
